import React from 'react';
import ContactForm from './ContactForm.jsx';
import style from './style.scss';

class Contact extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    let location = {lat: 21.0377415, lng: 105.8104033};
    let gmap = new window.google.maps.Map(document.getElementById('map'), {
      center: location,
      zoom: 13
    });
    new window.google.maps.Marker({
      position: location,
      map: gmap
    });
  }

  render() {
    return (
      <section className="center">
        <div className="contact-S">
          <h2 className="contact-S-title">Liên hệ</h2>
          <div className="contact-S-wrapper">
            <div className="contact-S-left-address">
              <div className="contact-S-address">
                <div className="contact-S-address-content">
                  <i className="fa fa-building-o contact-S-address-icon"/>
                  <span className="contact-S-address-des"><span className="strong-content">TRỤ SỞ: &nbsp;</span>Tầng 4, Hanoi Group. 442 Đội Cấn, Ba Đình, Hà Nội.</span>
                </div>
                <div className="contact-S-address-content">
                  <i className="fa fa-envelope contact-S-address-icon"/>
                  <span className="contact-S-address-des"><span className="strong-content">Email: &nbsp;</span>support@quangngaitrade.gov.vn</span>
                </div>
                <div className="contact-S-address-content">
                  <i className="fa fa-phone contact-S-address-icon"/>
                  <div className="contact-S-address-des-wrap">
                    <span className="contact-S-address-des"><span className="strong-content">Tổng đài hỗ trợ khách hàng: &nbsp;</span>1900 6750</span>
                    <span className="contact-S-address-des"><span className="strong-content">Tư vấn dịch vụ: &nbsp;</span>1900 6750 - Nhánh 1</span>
                  </div>
                </div>
                <div className="contact-S-address-content">
                  <i className="fa fa-clock-o contact-S-address-icon"/>
                  <span className="contact-S-address-des">Hỗ trợ từ 8h00 - 22h00 các ngày từ thứ 2 đến chủ nhật</span>
                </div>
              </div>
              <div className="contact-S-map">
                <div id="map">map</div>
              </div>
            </div>
            <div className="contact-S-right-forrm">
              <ContactForm/>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./components/contact/Contact.jsx